import styled from 'styled-components'
import tw from 'tailwind.macro'
import { ParallaxLayer } from 'react-spring/renderprops-addons.cjs'

const Content = styled.div`
  ${tw`p-2 sm:p-4 md:p-6 lg:px-8 lg:py-12 justify-center flex z-50`};
`

export default Content
